export const VIEWPORT_WIDTHS = {
  small: 576,
  medium: 1025,
  large: 1441,
};
